<template>
    <v-form v-model="valid" ref="form" @submit.prevent="next">
        <p class="text-center">
            Hubungi admin untuk mendaftar bimbingan belajar.
        </p>

        <contact-list></contact-list>
    </v-form>
</template>

<script>
import { sync } from 'vuex-pathify'
import ContactList from './ContactList'

export default {
    components: {
        ContactList,
    },

    data() {
        return {
            valid: null,
        }
    },

    computed: {
        groupName: sync('home/groupName')
    },

    methods: {
        required(value) {
            return !!value || 'Nama harus diisi'
        },

        next() {
            if (this.valid) {
                this.$emit('next')
            }
        }
    }
}
</script>
